/**
 * map through an object and return the result
 * @param obj the original object
 * @param mapper the mapper function to use
 */
export function mapObject(obj: any, mapper: (value: any) => any): any {
	const result: object = {};

	for (const [key, value] of Object.entries(obj)) {
		result[key] = mapper(value);
	}

	return result;
}



// WEBPACK FOOTER //
// ./src/utils/map_object.ts